﻿(function() {
  function initCollapsibles() {
    // Hide any empty or whitespace-only list items in collapsibles
    var listItems = document.querySelectorAll('.product-information .Collapsible__Content li');
    listItems.forEach(function(li) {
      if (!li.textContent || !li.textContent.trim()) {
        li.style.display = 'none';
      }
    });

    var buttons = document.querySelectorAll('.product-information .Collapsible__Button');
    buttons.forEach(function(btn) {
      var inner = btn.nextElementSibling;
      if (!inner || !inner.classList.contains('Collapsible__Inner')) return;

      // Initial state sync based on aria-expanded
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      inner.style.display = isExpanded ? 'block' : 'none';

      // Set click handler to toggle accordion
      btn.onclick = function(e) {
        e.preventDefault();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var nextState = !expanded;
        btn.setAttribute('aria-expanded', nextState ? 'true' : 'false');
        inner.style.display = nextState ? 'block' : 'none';
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibles);
  } else {
    initCollapsibles();
  }
})();
